import {mockUp} from "./mockup";
import {renderLoadmoreItem} from "./renderLoadmore";
import 'ion-rangeslider';
import qs from "qs";

export function initLoadmore(observer) {
    const AJAX_MODE = 'prod';
    //0 - кнопка показать варианты
    //1 - изменение данных в блоке подбор квартиры
    //2 - кнопка показать ещё (дозагрузка)

    const LOADMORE_CONFIG = {
        '0': {
            offset: 8,
            remains: 4,
            url: '/api/searchRooms/',
        },
        '1': {
            url: '/api/searchRooms/'
        },
        '2': {
            offset: 8,
            remains: 4,
            url: '/api/searchRooms/'
        },
    }

    const $searchWrapper = $('[data-search-flat]');
    const $loadMorePreloader = $('#loadmore_preloader');
    const $loadMoreButton = $('#loadmore_button');
    const $searchButton = $('[data-start-search]');
    const $sortButton = $('#sort_button');
    const $findBar = $('.find-bar');

    initChangesValues();

    if (!$searchWrapper.length || !$loadMorePreloader.length) return;

    const loadMoreType = $searchWrapper.data('search-wrapper');
    let isLoad = false;

    init();

    function init() {

        /*$($loadMoreButton).on('click',function (){
            if (LOADMORE_CONFIG[2].remains > 0 && !isLoad) {
                getElement(2);
            }
        });*/

        $(window).scroll(function () {
            OnScroll($searchWrapper, 2);

            function OnScroll(element, id) {
                const scroll = $(window).scrollTop() + $(window).height();
                const offset = element.offset().top + element.height();

                if (scroll > offset && LOADMORE_CONFIG[id].remains > 0 && !isLoad) {
                    getElement(2);
                }
            }
        });

        $($searchButton).on('click',function (){
            LOADMORE_CONFIG[2].remains = 4;
            if(window.innerWidth < 1000){
                $searchButton.addClass('transparent')
                setTimeout(() => {
                    $searchButton.removeClass('transparent')
                }, 200);
            }
            LOADMORE_CONFIG[2].offset = 8;
            $searchWrapper.empty();
            renderElements(0);
        });

        $sortButton.on('click', function (){
            const buttonText = $(this).find('.sort-text');
            const sortIcon = $(this).find('.icon-sort');
            if (buttonText.text() === 'Сначала маленькие') {
                buttonText.text('Сначала большие');
                sortIcon.attr('src','/img/icons/icon-sort-desc.svg')
                $searchWrapper.empty();
                renderElements(0, 'desc');
            } else {
                buttonText.text('Сначала маленькие');
                sortIcon.attr('src','/img/icons/icon-sort-asc.svg');
                $searchWrapper.empty();
                renderElements(0,'asc');
            }

        })
    }

    function renderElements(id,sortType) {

        isLoad = false;

        const data = {
            room: $('.flat-room .room.active').text().replace(/студия/gi, '0').split(''),
            areaMin: $('#area').data('min'),
            areaMax: $('#area').data('max'),
            priceMin: $('#price').data('min'),
            priceMax: $('#price').data('max'),
            search: 'search',
            sort: sortType,
            offset: 0,
            limit: 8
        }

        if ($('#checkbox_1').prop('checked')) {
            data.quiet = 'on';
        }

        if ($('#checkbox_2').prop('checked')) {
            data.urbanDynamics = 'on';
        }

        if ($('#checkbox_3').prop('checked')) {
            data.kitchenLiving = 'on';
        }

        if ($('#checkbox_4').prop('checked')) {
            data.twoBathrooms = 'on';
        }

        console.log(data)

        $.ajax({
            url: LOADMORE_CONFIG[id].url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            success: (data) => {
                if (data.result && data.result.length) {
                    showButtonPreLoader();
                    $findBar.find('.text').text(data.countFmt)
                    successFn(data, id);
                } else {
                    errorFn();
                }
            },
            error: (data) => {
                errorFn(data, id);
            },
        });
    }

    function getElement(id) {
        if(id === 2) {
            isLoad = true;
            showPreloader();
        }

        const dataPost = {
            room: $('.flat-room .room.active').text().replace(/студия/gi, '0').split(''),
            areaMin: $('#area').data('min'),
            areaMax: $('#area').data('max'),
            priceMin: $('#price').data('min'),
            priceMax: $('#price').data('max'),
            search: 'search',
            offset: LOADMORE_CONFIG[id].offset,
            limit: 4
        }

        if ($('#checkbox_1').prop('checked')) {
            dataPost.quiet = 'on';
        }

        if ($('#checkbox_2').prop('checked')) {
            dataPost.urbanDynamics = 'on';
        }

        if ($('#checkbox_3').prop('checked')) {
            dataPost.kitchenLiving = 'on';
        }

        if ($('#checkbox_4').prop('checked')) {
            dataPost.twoBathrooms = 'on';
        }

        $.ajax({
            url: LOADMORE_CONFIG[id].url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(dataPost),
            success: (data) => {
                if (data.result && data.result.length) {
                    successFn(data, id);
                } else {
                    errorFn();
                }
            },
            error: (data) => {
                errorFn(data, id);
            },
        });
    }


    function successFn(data, id) {
        LOADMORE_CONFIG[id].remains = data.remains;
        renderResult(id, data);
    }

    function errorFn(data, id) {
        if (AJAX_MODE === 'dev') {
            data = mockUp[id];
            successFn(data, id);
            return
        }
        hidePreloader();
    }

    function renderResult(type, data) {
        if(type === 1) return;
        const result = renderLoadmoreItem(data, type);
        $searchWrapper.append(result);
        LOADMORE_CONFIG[type].offset += data.result.length;
        observer.observe();
        if(type === 2){
        isLoad = false;
        hidePreloader();

        if(LOADMORE_CONFIG[type].remains === 0){
            hideButtonPreloader();
        }
        }
    }

    function hidePreloader() {
        $loadMorePreloader.addClass('hide');

    }

    function hideButtonPreloader(){
        $loadMoreButton.addClass('hide');
    }

    function showButtonPreLoader() {
        $loadMoreButton.removeClass('hide');
    }

    function showPreloader() {
        $loadMorePreloader.removeClass('hide');
        $loadMoreButton.removeClass('hide');
    }

    function initChangesValues(){
        const priceSliderData = $('#price');
        const areaSliderData = $('#area');
        const sliderArea = $('#slider_area');
        const sliderAreaMain = $('#slider_area_main');


        sliderArea.ionRangeSlider({
            skin: 'round',
            type: 'double',
            step: 0.1,
            min: sliderArea.data("min"),
            max: sliderArea.data("max"),
            from: sliderArea.data("from"),
            to: sliderArea.data("to"),
            grid: false,
            hide_min_max: true,
            hide_from_to: true,
            onChange: (data) => {
                areaSliderData.find("[data-number=1]").html(data.from);
                areaSliderData.find("[data-number=2]").html(data.to);
                areaSliderData.data('min',data.from);
                areaSliderData.data('max',data.to);
            },
            onFinish: (data) =>{
                updateSearchFlat();
            }
        })


        sliderAreaMain.ionRangeSlider({
            skin: 'round',
            type: 'double',
            step: 0.1,
            min: sliderAreaMain.data('min'),
            max: sliderAreaMain.data('max'),
            from: sliderAreaMain.data('from'),
            to: sliderAreaMain.data('to'),
            grid: false,
            hide_min_max: true,
            hide_from_to: true,
            onChange: (data) => {
                areaSliderData.find("[data-number=1]").html(data.from);
                areaSliderData.find("[data-number=2]").html(data.to);
                areaSliderData.data('min',data.from);
                areaSliderData.data('max',data.to);
            },
            onFinish: (data) =>{
                updateSearchFlat();
            }
        })

        //Переключение комнат в квартире, блок "подбор квартиры"
        $('.flat-room .room').on('click', function() {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            } else {
                if ($('.flat-room .room.active').length > 1) {
                    $(this).removeClass('active');
                }
            }
            updateSearchFlat();
        });

        //Функция обновления доступных квартир на блоке "Подбор квартиры"
        function updateSearchFlat(){

            const id = 1;

            const data = {
                room: $('.flat-room .room.active').text().replace(/студия/gi, '0').split(''),
                areaMin: $('#area').data('min'),
                areaMax: $('#area').data('max'),
                priceMin: $('#price').data('min'),
                priceMax: $('#price').data('max'),
                search: 'main'
            }

            if ($('#checkbox_1').prop('checked')) {
                data.quiet = 'on';
            }

            if ($('#checkbox_2').prop('checked')) {
                data.urbanDynamics = 'on';
            }

            if ($('#checkbox_3').prop('checked')) {
                data.kitchenLiving = 'on';
            }

            if ($('#checkbox_4').prop('checked')) {
                data.twoBathrooms = 'on';
            }

            formingUrl();

            $.ajax({
                url: '/api/searchRooms/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                success: (data) => {
                    console.log(data)
                    if (data) {
                        console.log(data)
                        $searchButton.html('Показать ' + data.countFmt);
                    } else {
                        errorFn();
                    }
                },
                error: (data) => {
                    errorFn(data, id);
                },
            });



        }

        function formingUrl(){
            const $searchFlatBlock = $('.select-flat');
            const $buttonSearchFlat = $('[data-start-search]');

            const data = {
                room: $('.flat-room .room.active').text().replace(/студия/gi, '0').split(''),
                areaMin: $('#area').data('min'),
                areaMax: $('#area').data('max'),
                priceMin: $('#price').data('min'),
                priceMax: $('#price').data('max'),
                search: 'main'
            }

            if ($('#checkbox_1').prop('checked')) {
                data.quiet = 'on';
            }

            if ($('#checkbox_2').prop('checked')) {
                data.urbanDynamics = 'on';
            }

            if ($('#checkbox_3').prop('checked')) {
                data.kitchenLiving = 'on';
            }

            if ($('#checkbox_4').prop('checked')) {
                data.twoBathrooms = 'on';
            }

            if($searchFlatBlock.data('search') == 'main'){

                let url = '/flats/comfort/';

                if(AJAX_MODE === 'dev'){
                    url = '/search-flat.html';
                }

                $buttonSearchFlat.attr('href', url + '?' + qs.stringify(data))
            } else {
                const currentUrl = window.location.origin + window.location.pathname;
// создаем новый URL
                let newUrl = currentUrl + '?' + qs.stringify(data);
// используем метод pushState для изменения URL
                window.history.replaceState({ path: newUrl }, '', newUrl);
            }
        }

        function numberWithSpaces(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }

        $('[data-checkbox]').on('change',function (){
            updateSearchFlat();
        })
    }

}